export default __webpack_public_path__ + "locales/ko-KR/DeleteProfileEverDialog.json?hash=771cf317cd2f5545298ee7ca60c248da";